import { PlayerInfoWithProjectionsFragment } from '@/api/events/query.generated';

import { NO_BREAK_SPACE } from './constants';

export const formatPlayerName = (
    { firstName, lastName }: Partial<PlayerInfoWithProjectionsFragment>,
    showFullName?: boolean
) => {
    return firstName && lastName
        ? `${showFullName ? firstName : `${firstName[0]}.`}${NO_BREAK_SPACE}${lastName}`
        : firstName || lastName || '';
};
